module.exports = __webpack_public_path__ + "fbce72acc02b05bd8cd0a1bb49361a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/arrow.png
// module id = 368
// module chunks = 1